import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { TopBar } from '../components/layout/TopBar';
export function Assessments() {
  const navigate = useNavigate();
  return <>
      <TopBar title="Assessments" data-id="element-2587" data-mp="jlcr1wov5xp4" />
      <div className="relative flex flex-1 flex-col items-center justify-center overflow-y-auto px-6 py-12 text-center" data-id="element-2588" data-mp="od48nhq1kt34">
        <div className="max-w-md" data-id="element-2589" data-mp="tda5dcb655s2">
          <CheckCircle2 className="mx-auto h-16 w-16 text-forest-green" strokeWidth={1.5} data-id="element-2590" data-mp="tc7f96lo77d7" />
          <h2 className="mt-6 font-[Figtree] text-2xl font-semibold text-evergreen" data-id="element-2591" data-mp="ya0iprvl9n9s">Assessments have moved</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-500" data-id="element-2592" data-mp="12dyhu2kwyy2u">
            Label scanning now runs inside each product's Packaging &amp; Label tab, so findings sit alongside the
            product's formula, claims and documents.
          </p>
          <button type="button" onClick={() => navigate('/dossiers')} className="mt-8 inline-flex items-center gap-2 rounded-xl bg-evergreen px-5 py-3 text-sm font-semibold text-white transition hover:bg-forest-green" data-id="element-2593" data-mp="3933gzsb01469">
            Go to Dossiers
            <ArrowRight className="h-4 w-4" data-id="element-2594" data-mp="q5mhqe8m7b20" />
          </button>
        </div>
      </div>
    </>;
}